import { z } from "zod";

import { priceSchema } from "./priceSchema";
import { productSchema } from "./productSchema";

export const subscriptionSchema = z.object({
  billing_issues_at: z.string().nullable(),
  display_metadata: z
    .object({
      title: z.string(),
      description: z.string(),
      details: z.string(),
      gifted_by_name: z.string().nullable().optional(),
    })
    .optional(),
  end_date: z.iso.datetime(),
  id: z.number(),
  is_owner: z.boolean(),
  is_renewing: z.boolean(),
  is_trial: z.boolean(),
  latest_receipt: z.string().nullable(),
  price_id: z.string().nullable(),
  product: z.string().nullable(),
  promo: z.string().nullable(),
  start_date: z.iso.datetime(),
  trial_ends_at: z.string().nullable(),
  type: z.string(),
  user_id: z.number(),
});

export const subscriptionsSchema = subscriptionSchema.array();

export type Subscription = z.infer<typeof subscriptionSchema>;

export const subscriptionDetailSchema = subscriptionSchema.extend({
  plan: productSchema,
  price: priceSchema.nullable(),
});

export type SubscriptionDetail = z.infer<typeof subscriptionDetailSchema>;

export const cancelSubscriptionSchema = z.object({
  is_refund_eligible: z.boolean(),
  subscription: subscriptionSchema,
});

export type CancelSubscriptionResponse = z.infer<
  typeof cancelSubscriptionSchema
>;

export const refundPaymentSchema = z.object({
  amount: z.number(),
  currency: z.string(),
  status: z.enum(["pending", "settled", "failed"]),
  created_at: z.iso.datetime(),
});

export type RefundPaymentResponse = z.infer<typeof refundPaymentSchema>;

export const subCancelFlowSchema = z.object({
  should_show_wrongly_charged: z.boolean(),
  should_offer_extended_trial: z.boolean(),
  has_prayed_enough: z.boolean(),
  should_offer_annual_discount: z.boolean(),
  should_offer_switch_to_monthly: z.boolean(),
});

export type SubCancelFlowDetails = z.infer<typeof subCancelFlowSchema>;
